import router from './router'
import { userStore } from './stores/user'
import { appStore } from './stores/app'
// import { Message } from 'element-ui'
// import { ElMessageBox  } from 'element-plus'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import { appRouters } from './router/app';
// import getPageTitle from '@/utils/get-page-title'
// import { mapGetters } from 'vuex';


NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/regist', '/registSuccess', '/auth-redirect', '/error'] // no redirect whitelist , '/auth-redirect'


router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)
  document.title = 'jtauth';

  const isAppRouter = appRouters.filter(x => {
    return x.path.toLocaleLowerCase() == to.path.toLocaleLowerCase();
  })[0];

  if (isAppRouter) {
    appStore().setAppByRouter(to.path);
  }
  
  console.log('permission to path', to.path, to.params, to.query)
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    console.log('hasToken')
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      console.log('redirect to login')
      next({ path: '/' })
      NProgress.done() // 
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      
      // const hasApps = store.getters.apps && store.getters.apps.length > 0
      let hasApps = userStore().accountId
      
      console.log('store', hasApps)
      if (hasApps) {
        next()
      } else {
        try {
          await userStore().getUser();

          next({ ...to, replace: true })
        } catch (error) {
          // console.log('elmessagebox alert', error, to.path);
          // ElMessageBox.alert(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    console.log('white list', to.path, whiteList.indexOf(to.path))
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      console.log('888', to.path)
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // console.log('router', `/login?redirect=${to.path || appStore().appRoute}`)
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
